gsap.registerPlugin(ScrollTrigger);
const ww = window.innerWidth;

// Only enable animations on desktop
if (ww > 700) {
  /**
   * Quote animations
   */
  // Heading fade-in
  const quoteContainer = document.querySelector('[data-quote-container]');
  const quoteSubtitle = quoteContainer?.querySelector('[data-quote-subtitle]');
  const quoteTitle = quoteContainer?.querySelector('[data-quote-title]');

  const quoteTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: quoteSubtitle
    }
  })

  if (quoteContainer) {
    quoteTimeline
      .from(quoteSubtitle, { duration: 1, y: '50px', opacity: 0, ease: 'Power2.easeOut' })
      .from(quoteTitle, { duration: 1, y: '50px', opacity: 0, ease: 'Power2.easeOut' }, '-=.8');
  }

  // Main image animation
  const mainImageWrapper = quoteContainer?.querySelector('[data-main-image-wrapper]');
  const mainImage = quoteContainer?.querySelector('[data-main-image]');

  if (quoteContainer) {
    gsap.from(mainImageWrapper, {
      scrollTrigger: {
        trigger: mainImageWrapper
      },
      duration: .7,
      scale: 0.9
    });
  
    gsap.from(mainImage, {
      scrollTrigger: {
        trigger: mainImageWrapper
      },
      duration: .7,
      scale: 1.2,
      y: '20px'
    });
  }

  // Left image animation
  const leftImage = quoteContainer?.querySelector('[data-left-image]');

  if (quoteContainer) {
    gsap.to(leftImage, {
      scrollTrigger: {
        trigger: mainImageWrapper,
        scrub: true
      },
      y: '50%'
    });
  }

  // Right image animation
  const rightImage = quoteContainer?.querySelector('[data-right-image]');

  if (quoteContainer) {
    gsap.to(rightImage, {
      scrollTrigger: {
        trigger: mainImageWrapper,
        scrub: true
      },
      y: '-30%'
    });
  }

  /**
   * Product section animations
   */
   const productContainers = document.querySelectorAll('[data-product-container]');

  if (productContainers) {
    productContainers.forEach(productContainer => {
      // Image animation
      const imageWrapper = productContainer.querySelector('[data-image-wrapper]');
      const image = productContainer.querySelector('[data-image]');

      gsap.from(imageWrapper, {
        scrollTrigger: {
          trigger: imageWrapper
        },
        duration: .7,
        scale: 0.9
      });
    
      gsap.from(image, {
        scrollTrigger: {
          trigger: imageWrapper
        },
        duration: .7,
        scale: 1.2,
        y: '20px'
      });

      // Text animation
      const textWrapper = productContainer.querySelector('[data-text-wrapper]');
      const productSubtitle = productContainer.querySelector('[data-subtitle]');
      const productText = productContainer.querySelector('[data-text]');
      const productCta = productContainer.querySelector('[data-cta]');
      const productTextTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: textWrapper
        }
      })
    
      productTextTimeline
        .from(productSubtitle, { duration: 1, y: '50px', opacity: 0, ease: 'Power2.easeOut' })
        .from(productText, { duration: 1, y: '50px', opacity: 0, ease: 'Power2.easeOut' }, '-=.8')
        .from(productCta, { duration: 1, y: '50px', opacity: 0, ease: 'Power2.easeOut' }, '-=.8');
    
      // Product elem animation
      const productElem = productContainer.querySelector('[data-product-elem]');
    
      gsap.to(productElem, {
        scrollTrigger: {
          trigger: imageWrapper,
          scrub: true,
          start: '30% center'
        },
        y: '-200px'
      });
    });
  }

  /**
   * Image fade-in animations
   */
  const imageAnimContainers = document.querySelectorAll('[data-anim-image-container]');

  if (imageAnimContainers) {
    imageAnimContainers.forEach(imageContainer => {
      const imageWrappers = imageContainer.querySelectorAll('[data-image-wrapper]');
      const images = imageContainer.querySelectorAll('[data-image]');
      const parallaxImages = imageContainer.querySelectorAll('[data-story-image-parallax]');

      if (imageWrappers) {
        imageWrappers.forEach(imageWrapper => {
          gsap.from(imageWrapper, {
            scrollTrigger: {
              trigger: imageWrapper
            },
            duration: .7,
            scale: 0.8,
            y: '-20px'
          });
        })
      }
    
      if (images) {
        images.forEach(image => {
          gsap.from(image, {
            scrollTrigger: {
              trigger: image
            },
            duration: .7,
            scale: 1.2,
            y: '20px'
          });
        })
      }

      if (parallaxImages) {
        parallaxImages.forEach(paraImage => {
          gsap.to(paraImage, {
            scrollTrigger: {
              trigger: paraImage,
              scrub: true
            },
            y: '-300px'
          })
        })
      }
    })
  }

  /**
   * Text fade-in animations
   */
  const textAnimContainers = document.querySelectorAll('[data-anim-text-container]');

  if (textAnimContainers) {
    textAnimContainers.forEach(textContainer => {
      const title = textContainer.querySelector('[data-title]');
      const text = textContainer.querySelector('[data-text]');
      const textTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: title,
        }
      })
    
      textTimeline
        .from(title, { duration: 1, y: '50px', opacity: 0, ease: 'Power3.easeOut' })
        .from(text, { duration: 1, y: '50px', opacity: 0, ease: 'Power3.easeOut' }, '-=.8');
    });
  }
}